import { SettingsSectionHeader } from '../common';
import { displayContent } from '../common/content';
import { DataFeedsFormSection } from '../common/DataFeedsFormSection';
import { GoogleAnalyticsFormSection } from '../common/GoogleAnalyticsFormSection';
import { LinkParametersFormSection } from '../common/LinkParametersFormSection';
import { LinkShorteningFormSection } from '../common/LinkShorteningFormSection';
import { TemplateNameField } from '../common/TemplateNameField';
import { useQueryParamContext } from '../context/QueryParamContext';
import { CustomPayloadSection } from './formFields/CustomPayloadSection';
import { SendingInformationSection } from './formFields/SendingInformationSection';
import { SubjectAndPreheaderSection } from './formFields/SubjectAndPreheaderSection';

export const SettingsForm = () => {
  const { campaignId } = useQueryParamContext();
  const isCampaignFlow = !!campaignId;

  return (
    <>
      {isCampaignFlow && (
        <>
          <SettingsSectionHeader>{displayContent.templateInformation}</SettingsSectionHeader>
          <TemplateNameField />
        </>
      )}

      <SendingInformationSection />
      <SettingsSectionHeader>{displayContent.headerContent}</SettingsSectionHeader>
      <SubjectAndPreheaderSection />
      <DataFeedsFormSection />
      <CustomPayloadSection />
      <SettingsSectionHeader>{displayContent.headerLinks}</SettingsSectionHeader>
      <GoogleAnalyticsFormSection isLinkShorteningEnabled={false} />
      <LinkParametersFormSection isLinkShorteningEnabled={false} />
      <LinkShorteningFormSection />
    </>
  );
};

export default SettingsForm;
